import {ObjectFactory} from "@commons/types";
import {merge} from "lodash";

export interface FasciaOrariaGG {
    inizio: string;
    fine: string;
}

export class FasciaOrariaGG {
    static factory: ObjectFactory<FasciaOrariaGG> = (json?) => {

        return merge<FasciaOrariaGG, Partial<FasciaOrariaGG> | undefined>({
            inizio: '0000',
            fine: '0000',
        }, json);
    }
    static getInizio = function (that: FasciaOrariaGG) {
        return parseInt(that.inizio);
    };
    static getFine = function (that: FasciaOrariaGG) {
        return parseInt(that.fine);
    };
    static isValid = function (that: FasciaOrariaGG) {
        return that.inizio && that.fine && that.inizio !== that.fine;
    }

}
